import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { DealsPage } from '@web/modules/deals/board/deals-page';
import { parseDealsSearch } from '@web/modules/deals/board/deals-search';
import { NewDealDialog } from '@web/modules/deals/create/new-deal-dialog';
import { parseImportSearch, withoutImport } from '@web/modules/imports/import-search';
import { parseCreateSearch, withoutCreate } from '@web/shared/util/create-search';
import { ImportDrawer } from '@web/modules/imports/wizard/import-drawer';

export const Route = createFileRoute('/_app/deals/')({
  // `?import=deals` opens the import drawer over the pipeline (spec 007 §7.2).
  validateSearch: (search: Record<string, unknown>) => ({
    ...parseDealsSearch(search),
    ...parseImportSearch(search, 'deals'),
    ...parseCreateSearch(search),
  }),
  component: DealsRoute,
});

function DealsRoute() {
  const routeSearch = Route.useSearch();
  const search = withoutCreate(withoutImport(routeSearch));
  const navigate = Route.useNavigate();
  // `undefined` = closed; otherwise the pipeline it opens on.
  const [creating, setCreating] = useState<{ pipelineId: string | undefined } | null>(null);
  return (
    <>
      <DealsPage
        search={search}
        onSearchChange={(next, options) =>
          void navigate({ search: next, replace: options?.replace })
        }
        onNewDeal={(pipelineId) => setCreating({ pipelineId })}
        onImport={() => void navigate({ search: { ...search, import: 'deals' } })}
      />
      <ImportDrawer
        entity="deals"
        open={routeSearch.import === 'deals'}
        onClose={() => void navigate({ search })}
      />
      <NewDealDialog
        open={creating !== null || routeSearch.new === true}
        onOpenChange={(open) => {
          if (open) return;
          setCreating(null);
          if (routeSearch.new) void navigate({ search });
        }}
        pipelineId={creating?.pipelineId}
        onCreated={(deal) => {
          setCreating(null);
          void navigate({ to: '/deals/$dealId', params: { dealId: deal.id } });
        }}
      />
    </>
  );
}
